import React from 'react';

// Every selection control in the flow: a 5px-radius square that fills brown
// with a white check. Never a circular radio.
const TickBox = ({
  checked,
  size = 18
}) => React.createElement("span", {
  className: `cp-tick${checked ? ' is-on' : ''}`,
  style: {
    width: size,
    height: size
  },
  "aria-hidden": "true"
}, React.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: "3.2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M20 6L9 17l-5-5"
})));
export default TickBox;
